import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownTransferContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownTransferContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownTransferContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownTransferContracts/${id}`, request)
}

export {get, post, put, patch}
